import { render, staticRenderFns } from "./CustInfoView.vue?vue&type=template&id=7a0be8ce&scoped=true"
import script from "./CustInfoView.vue?vue&type=script&lang=js"
export * from "./CustInfoView.vue?vue&type=script&lang=js"
import style0 from "./CustInfoView.vue?vue&type=style&index=0&id=7a0be8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0be8ce",
  null
  
)

export default component.exports